/**
 * @generated SignedSource<<11a1a32703cacde5deec1c81c2c89b03>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DiscountTableRowFragment$data = {
  readonly code: string | null;
  readonly id: string;
  readonly maxRedemptions: number | null;
  readonly name: string;
  readonly redemptions: {
    readonly totalCount: number;
  };
  readonly " $fragmentSpreads": FragmentRefs<"Discount_displayValue">;
  readonly " $fragmentType": "DiscountTableRowFragment";
};
export type DiscountTableRowFragment$key = {
  readonly " $data"?: DiscountTableRowFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DiscountTableRowFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DiscountTableRowFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxRedemptions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DiscountRedemptionNodeConnection",
      "kind": "LinkedField",
      "name": "redemptions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Discount_displayValue"
    }
  ],
  "type": "Discount",
  "abstractKey": null
};

(node as any).hash = "74a083741a9ddf67b84b262205848d61";

export default node;
